// Disabled for now: the host's self-update check produced excessive update dialogs.
// Updating is mandatory for non-developers but is currently managed by PlaycastLauncher
// and PlaycastService (which compare HKLM\SOFTWARE\Playcast\InstalledVersion against the
// manifest's installerVersion). Re-enable when the host should drive updates again.

export const UpdaterModal = () => {
  return null;
};

/*
import { Button, Dialog, DialogCustomContent, DialogDescription, Progress } from '@playcastdotio/Shadcn';
import { useContext, useEffect, useState } from 'react';
import { PlaycastContext } from '../PlaycastWrapper';
import constants from '@playcastdotio/GlobalConfig';
import * as Sentry from '@sentry/react';

export const UpdaterModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [showError, setShowError] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const context = useContext(PlaycastContext);

  const handleCloseUpdater = () => {
    setShowModal(false);
    if (context.electronFunctions) {
      if(window.playcast?.guestAccount) {
        Sentry.captureMessage('Guest Mode Host App Closed', {
          level: 'error',
          tags: {
            event_type: 'guest_mode_host_app_closed_from_updater',
            guest_mode: String(window.playcast?.guestAccount),
            version: constants.VERSION,
          },
        });
      }
      context.electronFunctions.setWindowState('closed');
    }
  };

  useEffect(() => {
    // if status is NOT streaming, we can show
    if (context.stateStores.hostState.status !== 'streaming' && context.stateStores.hostState.status !== 'starting') {
      console.log('Checking for updates');
      if (context.stateStores.versionState.hasUpdate) {
        console.log('Has update');
        // get ignored updates
        const ignoredUpdatesString = localStorage.getItem('ignoredUpdates');
        const ignoredUpdates = ignoredUpdatesString ? JSON.parse(ignoredUpdatesString) : [];
        if (ignoredUpdates.includes(context.stateStores.versionState.updateVersion)) {
          setShowModal(false);
        } else {
          setShowModal(true);
        }
      } else {
        setShowModal(false);
      }
    }
  }, [context.stateStores.hostState.status]);

  useEffect(() => {
    const status = context.stateStores.hostState.status;
    const canShow = status !== 'streaming' && status !== 'starting';
    if (context.stateStores.versionState.hasUpdate) {
      const ignoredUpdatesString = localStorage.getItem('ignoredUpdates');
      const ignoredUpdates = ignoredUpdatesString ? JSON.parse(ignoredUpdatesString) : [];
      if (ignoredUpdates.includes(context.stateStores.versionState.updateVersion)) {
        setShowModal(false);
      } else if (canShow) {
        setShowModal(true);
      }
    } else {
      setShowModal(false);
    }
  }, [
    context.stateStores.versionState.hasUpdate,
    context.stateStores.versionState.updateVersion,
    context.stateStores.hostState.status,
  ]);

  useEffect(() => {
    if (context.stateStores.versionState.downloadingUpdate || context.stateStores.versionState.downloadComplete) {
      setShowDownload(true);
    } else {
      setShowDownload(false);
    }
  }, [context.stateStores.versionState.downloadingUpdate, context.stateStores.versionState.downloadComplete]);

  useEffect(() => {
    if (context.stateStores.versionState.downloadFailed) {
      setShowError(true);
    }
  }, [context.stateStores.versionState.downloadFailed]);

  useEffect(() => {
    if (context.stateStores.versionState.downloadProgress) {
      setDownloadProgress(context.stateStores.versionState.downloadProgress);
    }
  }, [context.stateStores.versionState.downloadProgress]);

  const ignoreUpdate = () => {
    context.targetFunctions.ignoreUpdate();
    setShowModal(false);
  };

  // Steam/pavilion uses MinimalSteamLogin with an "Update" CTA instead of this modal.
  if (context.electronFunctions && context.stateStores.steamInstallState.steamInstall) {
    return null;
  }

  return (
    context.electronFunctions && (
      <Dialog open={showModal}>
        <DialogCustomContent className='w-2/6 border-none bg-gray-800 pb-2'>
          <div className='flex flex-col'>
            <div className='bg-midnight flex w-full justify-between rounded-t-md p-3'>
              <h1 className='w-full text-center text-xl font-bold text-white'>Update Required!</h1>
            </div>
            <div>
              {showError && (
                <DialogDescription>
                  <div className='flex flex-col justify-center'>
                    <p className='my-4 text-center text-white'>An error occurred while downloading...</p>
                    <p className='my-4 text-center text-white'>
                      Please download at{' '}
                      <a className='text-emerald-400' href='https://playcast.io/download'>
                        https://playcast.io/download
                      </a>
                    </p>
                    <Button
                      size='lg'
                      variant='default'
                      className='w-100 bg-gray-400 hover:bg-gray-500 focus:bg-gray-400 active:bg-gray-400'
                      onClick={handleCloseUpdater}
                    >
                      Exit
                    </Button>
                  </div>
                </DialogDescription>
              )}

              {!showError && showDownload && (
                <DialogDescription className='px-6'>
                  <p className='my-4 text-center text-white'>Downloading update...</p>
                  <Progress className='bg-gray-900 [&>div]:bg-green-500' value={downloadProgress} />
                </DialogDescription>
              )}

              {!showError && !showDownload && (
                <>
                  <DialogDescription className='pb-2'>
                    <p className='my-4 text-center text-white'>Playcast requires an update</p>
                  </DialogDescription>
                  <div className='flex justify-center space-x-4'>
                    <Button
                      size='lg'
                      variant='default'
                      className='bg-gray-400 hover:bg-gray-500 focus:bg-gray-400 active:bg-gray-400'
                      onClick={handleCloseUpdater}
                    >
                      Quit
                    </Button>
                    <Button
                      size='lg'
                      variant='default'
                      className='bg-emerald-400 hover:bg-emerald-500 focus:bg-emerald-400 active:bg-emerald-400'
                      onClick={() => context.targetFunctions.startUpdate()}
                    >
                      Update
                    </Button>
                  </div>
                  {constants.ENVIRONMENT === 'development' && (
                    <Button
                      size='lg'
                      variant='default'
                      className='w-100 bg-gray-400 hover:bg-gray-500 focus:bg-gray-400 active:bg-gray-400'
                      onClick={ignoreUpdate}
                      data-testid='ignore-update-button'
                    >
                      Ignore (im a dev)
                    </Button>
                  )}
                </>
              )}
            </div>
          </div>
        </DialogCustomContent>
      </Dialog>
    )
  );
};
*/
